// PKCE helpers for the Google federation redirect. The portal generates a verifier/challenge, sends
// the challenge to the Hosted UI authorize endpoint, stashes the verifier, and hands it to the broker
// on callback so it can complete the authorization-code exchange (public client → PKCE required).

const VERIFIER_KEY = 'wa_pkce_verifier'

function base64UrlEncode(bytes: Uint8Array): string {
  let str = ''
  for (const b of bytes) str += String.fromCharCode(b)
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function randomVerifier(): string {
  const bytes = new Uint8Array(64)
  crypto.getRandomValues(bytes)
  return base64UrlEncode(bytes)
}

export async function createPkceChallenge(): Promise<{ verifier: string; challenge: string }> {
  const verifier = randomVerifier()
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
  const challenge = base64UrlEncode(new Uint8Array(digest))
  return { verifier, challenge }
}

export function stashVerifier(verifier: string) {
  sessionStorage.setItem(VERIFIER_KEY, verifier)
}

export function takeVerifier(): string | null {
  const v = sessionStorage.getItem(VERIFIER_KEY)
  if (v) sessionStorage.removeItem(VERIFIER_KEY)
  return v
}
